module.exports = __webpack_public_path__ + "img/safety.3e767ace.jpg";